import React, { forwardRef, PropsWithChildren, RefObject } from 'react';
import classes from './Form.module.scss';
import { FCFormPageType, FormPageType } from 'new/elements/Form/useForm';

type FormPageProps = {
  index: number;
  children: FormPageType;
};

export const FormPage = forwardRef<HTMLDivElement, FormPageProps>(
  (props: FormPageProps, ref: RefObject<HTMLDivElement>) => {
    const { children, index } = props;

    if (!React.isValidElement(children)) {
      throw 'You provided an invalid element at index: ' + index;
    }

    // @ts-ignore
    if (!children.type?.formConfig) {
      throw 'You should define a formConfig in order to define a Form page. Do this by using FCFormPageType as the type of your component';
    }

    return (
      <div ref={ref} className={classes.formPageRoot}>
        {children}
      </div>
    );
  },
);
